import { useState } from "react";
import { MapPin } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";
import { useHubModuleWrite } from "@/lib/useHubModuleWrite";

import { KittingInventoryLocationChangeModal } from "./KittingInventoryLocationChangeModal";
import type { KittingPickInventorySelection } from "./kittingPickInventorySelection";

export function KittingInventoryLocationChangeButton({
  selection,
  knownStorageLocations,
  allowChangeSource = false,
  disabled = false,
  className,
}: {
  selection: KittingPickInventorySelection | null;
  knownStorageLocations: string[];
  allowChangeSource?: boolean;
  disabled?: boolean;
  className?: string;
}): JSX.Element {
  const canWrite = useHubModuleWrite("manufacturing");
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        size="sm"
        className={cn("gap-1.5", className)}
        disabled={!canWrite || disabled || selection == null}
        aria-label="Update inventory location"
        onClick={() => setOpen(true)}
      >
        <MapPin className="h-4 w-4" aria-hidden />
        <span className="xl:hidden">Location</span>
        <span className="hidden xl:inline">Update inventory location</span>
      </Button>
      <KittingInventoryLocationChangeModal
        open={open}
        selection={selection}
        knownStorageLocations={knownStorageLocations}
        allowChangeSource={allowChangeSource}
        onClose={() => setOpen(false)}
      />
    </>
  );
}
